export default __webpack_public_path__ + "static/improveCreditScore-2516790dafe1d9383fbb57d60928de24.webp";